import { Col, Row } from 'antd';
import { Field, Form } from 'react-final-form';

import Button from 'components/Button';
import { InputText } from 'components/InputField';
import icToggleOff from '../../../../image/ic-togge-off.svg';
import icToggleOn from '../../../../image/ic-toggle-on.svg';
import React from 'react';

type FormVersionMobileComponentProps = {
  visible: any;
  jenisToggle: any;
  isLoading: any;
  isView?: boolean;
  handleChange?: (name: string, value: any) => void;
  initialData: FormVersionMobileType;
  handleSubmit?: () => void;
};

export type FormVersionMobileType = {
  nameVersi: string;
  pic?: string;
  catatan: string;
  status: boolean;
};

export default function FormVersionMobileComponent({
  isLoading,
  isView,
  handleChange = () => undefined,
  initialData,
  handleSubmit = () => undefined,
}: FormVersionMobileComponentProps) {

  return (
    <Form
      onSubmit={handleSubmit}
      initialValues={{ ...initialData }}
      validate={values => {
        const errors = {} as any;
        if (!values.nameVersi) {
          errors.nameVersi = 'Nama Versi wajib diiis';
        }
        if (!values.catatan) {
          errors.catatan = 'Catatan wajib diiis';
        }
       
        return errors;
      }}
    >

      {({ handleSubmit, values }) => (
        <form
          className={'spacingTopDefault spacingColForm'}
          onSubmit={handleSubmit}
        >
          <Field name="status">
            {({ input }) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  // gap: 4,
                }}
              >
                <span>
                  <b>Status Versi</b>
                </span>
                <button name='updateVersion' style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  margin: 0,
                  cursor: 'pointer',
                  outline: 'none', width: 50,
                }}
                  onClick={value => handleChange('status', !input.value)}
                >
                  {
                    input.value ? (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <img src={icToggleOn} alt='#' style={{ width: 40, height: 40, marginRight: 4 }} />
                        <span className='lightBlueColor' >Aktif</span>
                      </div>
                    )
                      : (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img src={icToggleOff} alt='#' style={{ width: 40, height: 40, marginRight: 4 }} />
                          <span className='titleModalNotifFailed' >nonaktif</span>
                        </div>
                      )
                  }
                </button>
              </div>
            )}
          </Field>
          <Row gutter={[32, 32]}>
            <Col
              span={12}
              style={{ display: 'flex', flexDirection: 'column', gap: 18 }}
            >

              <Field name="nameVersi">
                {({ input, meta }) => (
                  <InputText
                    label="Nama Versi"
                    placeholder="Masukkan Nama Versi Aplikasi"
                    maxlength={15}
                    disabled={isView}
                    formStyle={{ margin: 0 }}
                    input={input}
                    meta={meta}
                    onChange={value => handleChange('nameVersi', value)}
                  />
                )}
              </Field>
            </Col>

            <Col
              span={12}
              style={{ display: 'flex', flexDirection: 'column', gap: 18 }}
            >
              <Field name="pic">
                {({ input, meta }) => (
                  <InputText
                    label="PIC"
                    placeholder="Admin"
                    maxlength={15}
                    disabled={true}
                    formStyle={{ margin: 0 }}
                    input={input}
                    meta={meta}
                    onChange={value => handleChange('lastName', value)}
                  />
                )}
              </Field>

            </Col>
          </Row>

          <Field name="catatan">
            {({ input, meta }) => (
              <InputText
                label="Catatan"
                placeholder="Masukkan catatan"
                disabled={isView}
                formStyle={{ margin: 0 }}
                textArea
                input={input}
                meta={meta}
                onChange={value => handleChange('catatan', value)}
              />
            )}
          </Field>
          {!isView && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                width: '100%',
              }}
            >
              <Button text="Simpan" htmlType="submit" loading={isLoading} />
            </div>
          )}
        </form>
      )}
    </Form>
  );
}
